/**
 * Created by litao on 2018/10/8.
 */

export default (http) => {
    return {
        /**
         * 分页查询
         * @param data
         * @return {*}
         */
        queryByPage (data){
            return http.json({
                url: `/sys/point/query?pageNum=${data.pageNum}&pageSize=${data.pageSize}`,
                data
            });
        },

        queryLeftJoinAccount (data){
            return http.json({
                url: `/sys/point/queryLeftJoinAccount?pageNum=${data.pageNum}&pageSize=${data.pageSize}`,
                data
            });
        },


        queryUserPoint(data){
            return http.json({
                url: `/sys/point/queryUserPoint`,
                data
            })
        },


        queryAllUserPointByPage(data){
            return http.json({
                url: `/sys/point/queryUserPoint`,
                data
            })
        },

        queryUserPointByCode(data) {
            return http.json({
                url: `/sys/point/queryUserPointByCode`,
                data
            });
        },



    }
}



// WEBPACK FOOTER //
// ./src/configure/http/api/sysPoint.js